import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { Lightbox } from 'angular2-lightbox';
import { SpeakerService } from '../speaker.service';

interface Image {
    src: string,
    caption: string,
    thumb: string
}

@Component({
  selector: 'student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class StudentComponent implements OnInit {

  images:Array<Image> = [];

  constructor(private _lightbox: Lightbox, private speakerSrv: SpeakerService) {
	  this.speakerSrv.statsChange.subscribe(stats => { console.log('stats'); this.update(stats); });
  }

  ngOnInit() {
    for (var i = 6; i > 0; i--) {
          const img: Image = {
              src: 'https://www.amcharts.com/wp-content/uploads/2014/03/demo_4074_light.jpg',
              caption: 'Placeholder!',
              thumb: 'https://www.amcharts.com/wp-content/uploads/2014/03/demo_4074_light.jpg'
          }
          this.images.push(img);
      }
      
  }

  update(stats) {
    let data = { labels: ['1994', '2014'] };
    if (Object.keys(stats).length > 0) {
      let corpusTotal = { '1994': {}, '2014': {} };
      for (let i = data.labels.length - 1; i >= 0; i--) {
        let l = data.labels[i];
        const objKeys = Object.keys(stats[l]);
        const pKeys = Object.keys(stats[l][objKeys[0]]);
        var obj = pKeys.reduce(function(acc, cur, i) {
          acc[cur] = {};
          return acc;
        }, {});
        corpusTotal[l] = Object.assign({}, obj);
        for (let j = objKeys.length - 1; j >= 0; j--) {
          for (var k = 0; k < pKeys.length; k++) {
            let value = stats[l][objKeys[j]][pKeys[k]];
            let key = pKeys[k];
            if (corpusTotal[l][key][value] != undefined) {
              corpusTotal[l][key][value] += 1;
            } else {
              corpusTotal[l][key][value] = 0;              
            }
          }
        }
      }
      //sort totals
      var merged = Object.assign({}, corpusTotal['1994']);
      for (var prop in corpusTotal['2014']) {
          for(var subprop in corpusTotal['2014'][prop]) {
            if (merged[prop][subprop]) {
              merged[prop][subprop] += corpusTotal['2014'][prop][subprop];
            } else {
              merged[prop][subprop] = corpusTotal['2014'][prop][subprop];  
            }
          }
          
      }
      console.log(merged);
      // Returning merged at this point will give you a merged object with properties summed, but not ordered.
      // var properties = [];
      // for (var prop in merged) {
      //     properties.push({
      //         name: prop,
      //         value: merged[prop]
      //     });
      // }
//       return properties.sort(function(nvp1, nvp2) {
//           return nvp1.value - nvp2.value;
// });
      console.log(corpusTotal);
      let oldTotal = corpusTotal['1994']['gender']['m'] + corpusTotal['1994']['gender']['f'];
      let newTotal = corpusTotal['2014']['gender']['m'] + corpusTotal['2014']['gender']['f'];
      let commonAge = this.getHighestValue(merged['age group'])[0][0];
      let commonClass = this.getHighestValue(merged['social grade'])[0][0];
      let commonArea = this.getHighestValue(merged['area'])[0][0];
      for(var i = 0; i < this.images.length; i++) {
        let img = this.images[i];
        let statement = "";
        switch (i) {
          case 0:
            if(merged['gender']['m'] < merged['gender']['f']) {
              statement = 'This phrase is used more by women';
            }else{
              statement = 'This phrase is used more by men';
            }
            break;
          case 1:
            if(oldTotal < newTotal) {
              statement = 'This phrase has become more used since 1994';
            }else{
              statement = 'This phrase has become less used since 1994';
            }
            break;
          case 2:
            statement = commonArea + ' is the most popular area for this';
            break;
          case 3:
            statement = 'This phrase is most popular among ' + commonAge + 'year olds';
            break;
          case 4:
            statement = 'This phrase is most popular in the  ' + commonClass + 'class group';
            break;
          case 5:
            statement = 'Talks & Materials';
            break;
          default:
            break;
        }

        img.caption = statement;
      }
    }
  }

  getHighestValue(obj) {
    var sortable = [];
    for (var k in obj) {
        sortable.push([k, obj[k]]);
    }

    sortable.sort(function(a, b) {
        return a[1] - b[1];
    });
    return sortable;
  }

  open(index: number): void {
    // open lightbox
    this._lightbox.open(this.images, index);
  }

}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/student/student.component.ts